import { render, staticRenderFns } from "./ChooseNotary.vue?vue&type=template&id=5429828e&"
import script from "./ChooseNotary.vue?vue&type=script&lang=ts&"
export * from "./ChooseNotary.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports